import {
    GET_LANGUAGE_OPTIONS,
    RECEIVED_LANGUAGE_OPTIONS,
    SET_CURRENT_LANGUAGE,
    GetLanguageOptions,
    ReceivedLanguageOptions,
    SetCurrentLanguage
} from "./types";
import { createAction } from "@reduxjs/toolkit";

export const getLanguageOptions = createAction<GetLanguageOptions["payload"]>(GET_LANGUAGE_OPTIONS);

export const receivedLanguageOptions =
    createAction<ReceivedLanguageOptions["payload"]>(RECEIVED_LANGUAGE_OPTIONS);

export const setCurrentLanguage = createAction<SetCurrentLanguage["payload"]>(SET_CURRENT_LANGUAGE);
